import isEmpty from 'lodash/isEmpty';
import type { IssueTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';
import type { EpicIdOption, TopFilter as State } from '../../common/types.tsx';

export const initialState: State = {
	epicIds: [],
	issueTypeIds: [],
};

export const actions = {
	setEpicIdsFilter:
		(epicIds: EpicIdOption[]): Action<State> =>
		({ setState }) =>
			setState({ epicIds }),
	setIssueTypeIdsFilter:
		(issueTypeIds: IssueTypeId[]): Action<State> =>
		({ setState }) =>
			setState({ issueTypeIds }),
	setFilter:
		(filter: State): Action<State> =>
		({ setState }) =>
			setState(filter),
	resetAllFilters:
		(): Action<State> =>
		({ setState }) =>
			setState(initialState),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'useTableFilterStore',
	initialState,
	actions,
});

export const useTableFilterStore = createHook(Store);

export const useHasAppliedFilters = createHook(Store, {
	selector: (state) => Object.values(state).some((val) => !isEmpty(val)),
});

export const useEpicIdsFilter = createHook(Store, {
	selector: (state) => state.epicIds,
});

export const useIssueTypeIdsFilter = createHook(Store, {
	selector: (state) => state.issueTypeIds,
});

export const isAnyFilterApplied = ({ epicIds, issueTypeIds }: State) =>
	!(epicIds.length === 0 && issueTypeIds.length === 0);
